module.exports = __webpack_public_path__ + "images/emoji/point_down.acfc4b9947401530c1e0.png";